import axios from "axios";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Div } from "../../StyledComponents";
import {
  Button1,
  Image,
} from "../setting/PatientPortalSettings/StyledComponents";
import { memo } from "react";
import Loader from "../popups/Loading";
import { WhatsNewUrl } from "../../axios/url.js";
import { Tabs } from "antd";
import Emp_data_pic from "../../assets/images/Emp_data_pic.png";

const { TabPane } = Tabs;

const NewSource = ({
  newOpen,
  setNewOpen,
  finalURL,
  newPostAlert,
  setNewPostAlert,
}) => {
  console.log(newPostAlert);
  const [blogData, setBlogData] = useState([]);
  const [spinner, setspinner] = useState(true);
  const [key, setKey] = useState("latestUpdates");

  const handleMore = (title) => {
    window.open(`https://www.vozohealth.com/blog/${title}`, "_blank");
  };

  const handleReleaseNote = () => {
    window.open(
      `https://help.vozohealth.com/product-guide/creating-a-trial-account/`,
      "_blank"
    );
  };

  let releaseNoteBullets = [
    " Fixed issues with Setting up Provider Availability.",
    "Improved Billing setup and Claim generation and Payment processing workflow.",
    "Reinvented note template workflow, which is used for clinical notes & patient forms.",
    "Mainstreamed Service codes and Permission based on providers usage.",
  ];

  useEffect(() => {
    axios
      .get(finalURL + "getNewFeatures.php")
      .then((res) => {
        setBlogData(Array.isArray(res.data) ? res.data : []);
        setspinner(false);
      })
      .catch((err) => {
        setBlogData([]);
        console.log(err.message);
      });

    const alertTimeout = setTimeout(() => {
      if (newPostAlert) {
        axios
          .get(WhatsNewUrl + "newPostAlert.php?type=post")
          .then((response) => {
            if (Number(response.data) === 0) {
              setNewPostAlert(false);
            }
          })
          .catch((err) => {
            console.log(err);
            setNewPostAlert(false);
          });
      }
    }, 5000);

    return () => {
      clearTimeout(alertTimeout);
    };
  }, []);

  return spinner ? (
    <Loader fromWhere="whatsnew_newsource" />
  ) : (
    <Modal
      show={newOpen}
      onHide={() => setNewOpen(false)}
      className="topnav_newSource"
      transition={null}
      animation={false}
    >
      <Modal.Header closeButton>
        <Modal.Title
          style={{
            fontSize: "18px",
            marginTop: "0px",
            marginLeft: "0px",
            fontWeight: "600",
            borderBottom: "none",
          }}
        >
          What's New
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tabs
          activeKey={key}
          onChange={(newKey) => setKey(newKey)}
          aria-label="new-source-tabs"
        >
          <TabPane
            tab={
              <>
                <p
                  className={newPostAlert ? "new_source_latest_red_dot" : ""}
                ></p>
                Latest Updates
              </>
            }
            key="latestUpdates"
          >
            <Div>
              {blogData.length > 0 ? (
                blogData.map((blogs) => (
                  <div key={blogs.id}>
                    <Div
                      display="flex"
                      alignItems="flex-start"
                      textAlign="left"
                    >
                      <Div
                        fontSize="18px"
                        fontWeight="600"
                        color="#2E2E2E"
                        width="445px"
                      >
                        {blogs.title}
                      </Div>
                      <Div
                        marginLeft="auto"
                        fontSize="14px"
                        fontWeight="600"
                        paddingLeft="20px"
                        paddingTop="5px"
                        color="rgba(46, 46, 46, 0.5)"
                      >
                        {blogs.date}
                      </Div>
                    </Div>
                    <Div fontSize="14px" fontWeight="400" paddingTop="16px">
                      {blogs.content}
                    </Div>
                    <Button1
                      type="button"
                      fontSize="14px"
                      fontWeight="400"
                      color="#2C7BE5"
                      padding="0px"
                      paddingTop="8px"
                      backgroundColor="#fff"
                      onClick={() => handleMore(blogs.formatTitle)}
                    >
                      Learn more
                    </Button1>
                    <hr />
                  </div>
                ))
              ) : (
                <div className="img_top">
                  <Image
                    height="133px"
                    width="100%"
                    margin="0 auto"
                    src={Emp_data_pic}
                  ></Image>
                </div>
              )}
            </Div>
          </TabPane>

          <TabPane tab="Release Notes" key="releaseNotes">
            <Div>
              <Div display="flex" alignItems="flex-start" textAlign="left">
                <Div
                  fontSize="18px"
                  fontWeight="600"
                  color="#2E2E2E"
                  width="445px"
                >
                  Release Notes for March 2025
                </Div>
                <Div
                  marginLeft="auto"
                  fontSize="14px"
                  fontWeight="600"
                  paddingLeft="20px"
                  paddingTop="5px"
                  color="rgba(46, 46, 46, 0.5)"
                >
                  March 21, 2025
                </Div>
              </Div>
              <Div fontSize="14px" fontWeight="400" paddingTop="16px">
                EHR has been completely upgraded with enhanced UI and workflow
                improvements on billing and note templates, making it more
                user-friendly and efficient for healthcare providers. Some of
                the changes that addressed in this improvement are:
              </Div>

              <Div fontSize="14px" fontWeight="400" paddingTop="16px">
                <ul>
                  {releaseNoteBullets.map((notes, index) => (
                    <li key={index}>{notes}</li>
                  ))}
                </ul>
              </Div>

              <Div paddingTop="16px">
                To know more about the recent updates & releases, click
                <Button1
                  type="button"
                  fontSize="14px"
                  fontWeight="400"
                  color="#2C7BE5"
                  padding="0px"
                  paddingTop="8px"
                  backgroundColor="#fff"
                  paddingLeft="5px"
                  onClick={handleReleaseNote}
                >
                  Learn more
                </Button1>
              </Div>
              <hr />
            </Div>
          </TabPane>
        </Tabs>
      </Modal.Body>
    </Modal>
  );
};

export default memo(NewSource);
